import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

import { PhotoOptionsModel } from './PhotoOptions';

export class Photo extends Model({
  // TODO: Think about better typing
  thumbnail: types.maybe(PhotoOptionsModel),
  small: types.maybe(PhotoOptionsModel),
  normal: types.maybe(PhotoOptionsModel),
  big: types.maybe(PhotoOptionsModel),
}) {}

export const PhotoModel = model(Photo);
